import { toDate } from "@flaminem/utils";

import {
  CustomerSummaryFragmentFragment,
  CustomerFragmentFragment,
  CaseSummaryFragmentFragment,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { CustomerSummary, Customer, CaseForCustomer } from "src/types/customer";

import { mapToAlertSummary } from "./alert.mappers";
import { mapToCaseSummary } from "./case.mappers";
import { mapToElement } from "./element.mappers";
import { mapToPropertyValue } from "./property.mappers";

export const mapToCustomerSummary = (
  fragment: CustomerSummaryFragmentFragment
): CustomerSummary => {
  const properties = fragment.properties.map(mapToPropertyValue);
  return {
    id: fragment.id,
    properties,
    elements: fragment.elements.map(mapToElement),
    nbrOfOpenAlerts: fragment.numberOfOpenAlerts,
    lastModification: toDate(fragment.adminStatus.lastModification),
  };
};

export const mapToCustomer = (fragment: CustomerFragmentFragment): Customer => {
  const properties = fragment.properties.map(mapToPropertyValue);
  return {
    id: fragment.id,
    properties,
    elements: fragment.elements.map(mapToElement),
    typeCode: fragment.typeCode,
    openAlerts: fragment.openAlerts.map(mapToAlertSummary),
  };
};

export const mapToCustomerCases = (
  fragment: CaseSummaryFragmentFragment & { alerts: { id: string }[] }
): CaseForCustomer => {
  return {
    ...mapToCaseSummary(fragment),

    hasAlert: fragment.alerts.length > 0 ? true : false,
  };
};
